import { Theme, useTheme } from '@emotion/react'
import { FieldProps } from 'formik'
import { CSSProperties } from 'react'
import { StylesConfig, mergeStyles } from 'react-select'

import { SelectStyled } from '../_styles'

interface Option {
    label: string
    value: string
}

interface MySelectProps {
    label: string
    options: Option[]
    hasError?: boolean
}

const customControlStyles: CSSProperties = {
    color: 'white',
    borderColor: 'pink',
}

const selectStyle = (theme: Theme, hasError: boolean): StylesConfig<any, false, any> => {
    return {
        control: (styles) => ({
            ...styles,
            padding: theme.spacing(2),
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            fontSize: theme.spacing(2),
            border: hasError
                ? `1px solid ${theme.color.semantic.error[300]}`
                : `1px solid ${theme.color.neutral.slate[100]}`,
        }),
        input: (styles) => ({
            ...styles,
            fontSize: 16,
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            padding: '0px 4px',
        }),
    }
}

const MySelect: React.FC<MySelectProps & FieldProps> = ({
    field,
    form,
    options,
    label,
    hasError = false,
    ...props
}) => {
    const theme = useTheme()

    return (
        <SelectStyled
            {...field}
            {...props}
            styles={selectStyle(theme, hasError)}
            options={options}
            value={(options ? options.find((option) => option.value === field.value) : '') as any}
            onChange={(option) => form.setFieldValue(field.name, (option as any).value)}
        />
    )
}

export default MySelect
